import React, { useState } from "react";
import { Modal, ModalHeader, Button, ModalBody } from "reactstrap";
import { useDispatch, useSelector } from "react-redux";
import { addOrUpdateAddon } from "store/actions/cartAction";
import { addOrUpdateNewAddon } from "store/actions/orderActions";
import { checkFinalPrice } from "../checkFinalPrice";
import { toast } from "react-toastify";
import "assets/scss/custom.scss";

const SelectAddonsModal = ({
  addons,
  orderItemID,
  isOpen,
  toggler,
  type = "newOrder",
}) => {
  const dispatch = useDispatch();
  const { updatedOrder } = useSelector((state) => state.orders);
  const { orderItems } = useSelector((state) => state.cart);
  const { restaurantsDetail } = useSelector((state) => state.restaurant);
  const [isAdding, setIsAdding] = useState(false);

  const cartItems = type === "newOrder" ? orderItems : updatedOrder.order;

  const handleAddonSelect = (orderItemID, addon) => {
    const simulatedFinal = checkFinalPrice({
      cartItems,
      restaurant: restaurantsDetail,
      itemPrice: parseFloat(addon?.price),
    });
    if (simulatedFinal > 10000) {
      toast.warning("Total amount limit per order is 10,000.");
      return;
    }
    setIsAdding(true);
    if (type === "updateOrder") {
      dispatch(addOrUpdateNewAddon(orderItemID, addon));
    } else {
      dispatch(addOrUpdateAddon(orderItemID, addon));
    }
    setTimeout(() => setIsAdding(false), 200);
  };

  const cardBg = "#f0f0f0";
  const cardStyle = {
    backgroundColor: cardBg,
    padding: "14px 18px",
    borderRadius: "10px",
    border: "1px solid #ddd",
    boxShadow: "0 4px 12px rgba(0,0,0,0.05)",
    transition: "all 0.2s ease-in-out",
  };

  return (
    <Modal isOpen={isOpen} toggle={toggler} size="md">
      <ModalHeader
        toggle={toggler}
        className="align-items-center border-bottom py-3"
      >
        Select Addons
      </ModalHeader>
      <ModalBody>
        {addons?.length > 0 ? (
          <>
            <div
              className="d-flex flex-column"
              style={{ gap: "12px", marginBottom: "1rem" }}
            >
              {addons?.map((addOn, idx) => {
                const hasDescription = Boolean(addOn?.description?.trim());

                const simulatedFinal = checkFinalPrice({
                  cartItems,
                  restaurant: restaurantsDetail,
                  itemPrice: parseFloat(addOn?.price),
                });

                const isDisabled = isAdding || simulatedFinal > 10000;

                return (
                  <div className="addon-card d-flex align-items-center">
                    <img
                      src={addOn?.image}
                      alt={addOn?.name}
                      width={52}
                      height={52}
                      className="addon-image"
                    />
                    <div className="addon-content flex-grow-1 text-center px-3">
                      <strong className="addon-title text-truncate">
                        {addOn?.name}
                      </strong>

                      <div className="addon-price">
                        {addOn?.price === 0 ? "Free" : `$${addOn?.price}`}
                      </div>

                      {hasDescription && (
                        <p
                          className="addon-description mb-0"
                          title={addOn?.description}
                        >
                          {addOn?.description}
                        </p>
                      )}
                    </div>
                    <Button
                      size="sm"
                      color={isDisabled ? "secondary" : "primary"}
                      disabled={isDisabled}
                      className="addon-btn"
                      onClick={() => handleAddonSelect(orderItemID, addOn)}
                    >
                      Add
                    </Button>
                  </div>
                );
              })}
            </div>
          </>
        ) : (
          <p>No addons available.</p>
        )}
      </ModalBody>
    </Modal>
  );
};

export default SelectAddonsModal;
